import { GenericCheckboxStep } from '../steps';
import { PHAdviceOptions } from '../../enums';

function PHAdviceStep() {
  return (
    <GenericCheckboxStep
      title="What do you have questions about?"
      subtitle="Select all that apply."
      checkboxOptions={PHAdviceOptions}
      referralFieldName="ph_tax_advice"
    />
  );
}

export { PHAdviceStep };
